/* Picskis 2026 — small behaviours for the pk-* sections (no libraries). */
(function () {
  var root = document.documentElement;
  root.classList.add('pk-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(scope) {
    scope = scope || document;

    // Gentle reveal as sections come into view
    var items = scope.querySelectorAll('.pk-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      items.forEach(function (el) { io.observe(el); });
    }

    // Hero books: closed stack → fanned out on load, opening fully as you scroll (and on hover)
    scope.querySelectorAll('[data-pk-fan]').forEach(function (fan) {
      if (fan.__pk) return; fan.__pk = true;
      var inHero = !!fan.closest('.pk-hero');
      // hero: nearly stacked on arrival, fully open after a short scroll; cards: open as they come into view
      // resting state is a proper fan (never squashed); scrolling / hover spread it the rest of the way
      var base = inHero ? 0.82 : 0.7, start = inHero ? 0.5 : 0.45, hover = false, ticking = false;
      function scrolled() {
        if (inHero) return Math.max(0, Math.min(1, (window.scrollY || 0) / ((window.innerHeight || 800) * 0.22)));
        var r = fan.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        // 0 while the books sit low on the screen, 1 once they've moved up about a third of it
        return Math.max(0, Math.min(1, (vh - r.bottom + vh * 0.12) / (vh * 0.35)));
      }
      function apply() {
        ticking = false;
        var open = hover ? 1 : base + (1 - base) * scrolled();
        fan.style.setProperty('--open', open.toFixed(3));
      }
      if (reduce) { fan.style.setProperty('--open', '1'); return; }
      // glide in from a little tighter to the resting fan
      fan.style.setProperty('--open', String(start));
      fan.classList.add('is-animating');
      requestAnimationFrame(function () { requestAnimationFrame(apply); });
      setTimeout(function () { fan.classList.remove('is-animating'); }, 1400);
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }, { passive: true });
      // the whole card opens its books on hover (format cards); otherwise the books themselves
      var hoverEl = fan.closest('[data-pk-fan-hover]') || fan;
      hoverEl.addEventListener('mouseenter', function () { hover = true; fan.classList.add('is-animating'); apply(); });
      hoverEl.addEventListener('mouseleave', function () { hover = false; apply(); setTimeout(function () { if (!hover) fan.classList.remove('is-animating'); }, 900); });
    });

    // Shelf: collection tabs + photobook / magazine switch + arrows
    scope.querySelectorAll('[data-pk-shelf]').forEach(function (shelf) {
      if (shelf.__pk) return; shelf.__pk = true;
      var tabs = shelf.querySelectorAll('[data-pk-tab]');
      var kind = 'book';
      function show(id) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.getAttribute('data-pk-tab') === id)); });
        // A tab without magazines shows its photobooks
        var want = shelf.querySelector('[data-pk-panel="' + id + ':' + kind + '"]') ? id + ':' + kind : id + ':book';
        shelf.querySelectorAll('[data-pk-panel]').forEach(function (p) {
          var on = p.getAttribute('data-pk-panel') === want;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
        var cur = shelf.querySelector('[data-pk-panel].is-active');
        var more = shelf.querySelector('[data-pk-more]');
        if (more && cur) { more.href = cur.getAttribute('data-more') || more.href; }
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-pk-tab')); });
      });
      shelf.querySelectorAll('[data-pk-kind]').forEach(function (b) {
        b.addEventListener('click', function () {
          kind = b.getAttribute('data-pk-kind');
          shelf.querySelectorAll('[data-pk-kind]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          var sel = shelf.querySelector('[data-pk-tab][aria-selected="true"]');
          show(sel ? sel.getAttribute('data-pk-tab') : tabs[0].getAttribute('data-pk-tab'));
        });
      });
      shelf.querySelectorAll('[data-pk-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var track = shelf.querySelector('[data-pk-panel].is-active .pk-shelf__track');
          if (!track) return;
          var dir = Number(b.getAttribute('data-pk-step'));
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      if (tabs[0]) show(tabs[0].getAttribute('data-pk-tab'));
      // Product page: start the rail at the design you're looking at
      var here = shelf.querySelector('.pk-shelf__panel.is-active .pk-book.is-current');
      if (here) { var tr = here.parentElement; tr.scrollLeft = Math.max(0, here.offsetLeft - tr.offsetLeft - (tr.clientWidth - here.offsetWidth) / 2); }
    });

    // Catalogue: the jump bar glides to a collection and follows along as you scroll
    scope.querySelectorAll('[data-pk-cat]').forEach(function (cat) {
      if (cat.__pk) return; cat.__pk = true;
      var links = cat.querySelectorAll('[data-pk-jump]');
      function mark(id) {
        links.forEach(function (a) {
          var on = a.getAttribute('href') === '#' + id;
          a.setAttribute('aria-selected', String(on));
          if (on && a.scrollIntoView && a.parentElement.scrollWidth > a.parentElement.clientWidth) {
            a.parentElement.scrollTo({ left: a.offsetLeft - 24, behavior: reduce ? 'auto' : 'smooth' });
          }
        });
      }
      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var target = cat.querySelector(a.getAttribute('href'));
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          mark(target.id);
        });
      });
      if ('IntersectionObserver' in window) {
        var gio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) mark(e.target.id); });
        }, { rootMargin: '-35% 0px -60% 0px' });
        cat.querySelectorAll('[data-pk-group]').forEach(function (g) { gio.observe(g); });
      }
    });

    // Real-life videos: load and play only while on screen (muted, looping); still images if motion is reduced
    scope.querySelectorAll('[data-pk-reels] video').forEach(function (v) {
      if (v.__pk) return; v.__pk = true;
      if (reduce || !('IntersectionObserver' in window)) return;
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var src = v.querySelector('source[data-src]');
            if (src) { src.src = src.getAttribute('data-src'); src.removeAttribute('data-src'); v.load(); }
            var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          } else { v.pause(); }
        });
      }, { threshold: 0.35 });
      vio.observe(v);
    });

    // Product gallery: thumbnails follow the swipe, and jump to a photo when tapped
    scope.querySelectorAll('[data-pk-gallery]').forEach(function (g) {
      if (g.__pk) return; g.__pk = true;
      var track = g.querySelector('[data-pk-gallery-track]');
      var thumbs = g.querySelectorAll('[data-pk-thumb]');
      if (!track) return;
      function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function mark(i) { thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); }); }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = Number(t.getAttribute('data-pk-thumb'));
          track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
          mark(i);
        });
      });
      var st;
      track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { mark(current()); }, 60); }, { passive: true });
    });

    // Cart: trust badges sit under the checkout button, and the bundle bar follows quantity changes
    var top = scope.querySelector('[data-pk-cart-top]');
    if (top && !top.__pk) {
      top.__pk = true;
      var trust = top.querySelector('[data-pk-cart-trust]');
      var placeTrust = function () {
        var ctas = document.querySelector('.cart__ctas');
        if (trust && ctas && trust.parentNode !== ctas) ctas.appendChild(trust);
      };
      placeTrust();
      var sec = top.closest('.shopify-section');
      var sid = sec && sec.id.replace('shopify-section-', '');
      document.addEventListener('cart:update', function () {
        setTimeout(placeTrust, 300);
        if (!sid) return;
        fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid))
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var doc = new DOMParser().parseFromString(j[sid] || '', 'text/html');
            var fresh = doc.querySelector('[data-pk-cart-top] .pk-wrap'), cur = top.querySelector('.pk-wrap');
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
            placeTrust();
          })
          .catch(function () {});
      });
    }

    // Side cart: the bundle bar under the heading and trust badges under the checkout button
    // (rendered by the pk-cart-top section through Shopify's section rendering, so the numbers match the cart page)
    if (!window.__pkDrawer && document.querySelector('cart-drawer-component')) {
      window.__pkDrawer = true;
      var bundleEl = null, trustEl = null, cardEl = null;
      var placeDrawer = function () {
        var drawer = document.querySelector('cart-drawer-component .cart-drawer__inner');
        if (!drawer) return;
        var head = drawer.querySelector('.cart-drawer__header');
        if (bundleEl && head && head.nextElementSibling !== bundleEl) head.parentNode.insertBefore(bundleEl, head.nextSibling);
        // the letter card sits right under the bundle bar, always in view
        var anchorEl = (bundleEl && bundleEl.parentNode) ? bundleEl : head;
        if (cardEl && anchorEl && anchorEl.nextElementSibling !== cardEl) anchorEl.parentNode.insertBefore(cardEl, anchorEl.nextSibling);
        var ctas = drawer.querySelector('.cart__ctas');
        if (trustEl && ctas && trustEl.parentNode !== ctas) ctas.appendChild(trustEl);
      };
      var loadDrawer = function () {
        fetch('/?sections=pk-cart-top')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var doc = new DOMParser().parseFromString(j['pk-cart-top'] || '', 'text/html');
            var b = doc.querySelector('.pk-cart-bundle'), t = doc.querySelector('.pk-cart-trust');
            if (bundleEl && bundleEl.parentNode) bundleEl.parentNode.removeChild(bundleEl);
            bundleEl = b ? document.importNode(b, true) : null;
            if (bundleEl) bundleEl.classList.add('pk-cart-bundle--drawer');
            var c = doc.querySelector('.pk-cart-card');
            if (cardEl && cardEl.parentNode) cardEl.parentNode.removeChild(cardEl);
            cardEl = c ? document.importNode(c, true) : null;
            if (cardEl) cardEl.classList.add('pk', 'pk-cart-card--drawer');
            if (!trustEl && t) { trustEl = document.importNode(t, true); trustEl.classList.add('pk', 'pk-cart-trust--drawer'); }
            placeDrawer();
          })
          .catch(function () {});
      };
      loadDrawer();
      document.addEventListener('cart:update', function () { setTimeout(loadDrawer, 250); });
      var dlg = document.querySelector('cart-drawer-component');
      if ('MutationObserver' in window) new MutationObserver(function () { placeDrawer(); }).observe(dlg, { childList: true, subtree: true });
    }

    // Delivery estimate: real dates from today
    scope.querySelectorAll('[data-pk-eta]').forEach(function (el) {
      if (el.__pk) return; el.__pk = true;
      var fmt = function (d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); };
      var add = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
      var pr = Number(el.getAttribute('data-print')) || 3, a = Number(el.getAttribute('data-from')) || 6, b = Number(el.getAttribute('data-to')) || 8;
      var s0 = el.querySelector('[data-pk-eta-0]'), s1 = el.querySelector('[data-pk-eta-1]'), s2 = el.querySelector('[data-pk-eta-2]');
      if (s0) s0.textContent = fmt(new Date());
      if (s1) s1.textContent = fmt(add(pr));
      if (s2) s2.textContent = fmt(add(a)) + ' – ' + fmt(add(b));
    });

    // Product page: a slim start bar once the main button has scrolled away
    var bar = scope.querySelector('[data-pk-bar]');
    if (bar && !bar.__pk && 'IntersectionObserver' in window) {
      bar.__pk = true;
      var form = document.querySelector('[data-pk-buy]');
      if (form) {
        bar.hidden = false;
        var bio = new IntersectionObserver(function (entries) {
          var e = entries[0];
          bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
        bio.observe(form);
        bar.querySelector('[data-pk-bar-go]').addEventListener('click', function () {
          var btn = document.getElementById('piclabs-customize-btn') || form.querySelector('button[type="submit"]');
          if (btn) btn.click();
        });
      }
    }

    // FAQ: smooth open/close for <details>
    scope.querySelectorAll('.pk-q').forEach(function (d) {
      if (d.__pk) return; d.__pk = true;
      var summary = d.querySelector('summary');
      var body = d.querySelector('.pk-q__a');
      summary.addEventListener('click', function (e) {
        if (reduce || !body.animate) return;
        e.preventDefault();
        if (d.open) {
          var h = body.offsetHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.2,.7,.1,1)' }).onfinish = function () { d.open = false; };
        } else {
          d.open = true;
          var h2 = body.offsetHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 460, easing: 'cubic-bezier(.2,.7,.1,1)' });
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Theme editor: sections are re-rendered in place
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ── Visitors abroad (window.PK_INTL, set in theme.liquid outside Egypt) ──────────────────────────────
   Prices: "EGP 1,830 ≈ AED 128" (they pay in EGP; the local amount is a guide). Magazines and gift cards
   aren't sold abroad yet: the magazines page says so, and any already in the cart are taken out. */
(function () {
  var intl = window.PK_INTL;
  if (!intl) return;
  var API = 'https://api.getpiclabs.com', SHOP = 'u41iuv-xm.myshopify.com', FALLBACK_VARIANT = '67437757956254';
  var KEY = 'pk_fx_' + intl.cc;
  var store = { get: function (k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } },
                set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} } };

  function rate() {
    var c = store.get(KEY);
    if (c && c.at > Date.now() - 6 * 3600e3) return Promise.resolve(c);
    var form = document.querySelector('[data-pk-buy][data-variant]');
    var v = (form && form.getAttribute('data-variant')) || FALLBACK_VARIANT;
    return fetch(API + '/api/v1/storefront/market-price?shop=' + SHOP + '&country=' + intl.cc + '&variant=' + v)
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (m) { var o = m && m.localCurrency && m.localRate > 0 ? { cur: m.localCurrency, rate: m.localRate, at: Date.now() } : null; if (o) store.set(KEY, o); return o; })
      .catch(function () { return null; });
  }
  function approx(egp, fx) {
    var v = egp * fx.rate, d = v >= 100 ? 0 : (v >= 10 ? 1 : 2);
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: fx.cur, minimumFractionDigits: 0, maximumFractionDigits: d }).format(v); }
    catch (e) { return fx.cur + ' ' + v.toFixed(d); }
  }
  var num = function (t) { var m = String(t).replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; };

  function paint(fx) {
    var els = document.querySelectorAll('.pk-pp__amount, .pk-book__price, .money');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest('.pk-fx')) continue;
      // Prices drawn by the currency app (.money) are left as they are — only the guide line is added
      var isMoney = el.classList.contains('money');
      if (!isMoney && el.querySelector('.money')) continue;
      var text = el.textContent.trim();
      if (el.getAttribute('data-pk-fx') === text) continue;
      var egp = num(text);
      if (!isFinite(egp) || egp <= 0) continue;
      // Our own price text: "EGP 1,830" (the code they'll see at checkout) instead of "LE 1,830"
      if (!isMoney) {
        var bare = text.replace(/^LE\s?/, '').replace(/^EGP\s?/, '').replace(/\s*EGP\s*$/, '');
        if (el.textContent !== 'EGP ' + bare) el.textContent = 'EGP ' + bare;
      }
      el.setAttribute('data-pk-fx', el.textContent.trim());
      var next = el.nextElementSibling;
      if (!next || !next.classList.contains('pk-fx')) { next = document.createElement('span'); next.className = 'pk-fx'; el.insertAdjacentElement('afterend', next); }
      next.textContent = '≈ ' + approx(egp, fx);
    }
  }

  function note(text) {
    if (document.querySelector('.pk-intl-note')) return;
    var host = document.querySelector('main') || document.body;
    var n = document.createElement('div');
    n.className = 'pk-intl-note'; n.setAttribute('role', 'status');
    n.innerHTML = '<span aria-hidden="true">📰</span><span></span>';
    n.lastChild.textContent = text;
    host.insertBefore(n, host.firstChild);
  }

  // Magazines and gift cards already in the cart come out (their extra-pages lines follow automatically)
  function cleanCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var updates = {}, mags = 0, gifts = 0;
      (cart.items || []).forEach(function (it) {
        var extra = it.product_type === 'Photobook extra pages' || /^extra-pages/.test(it.handle || '');
        if (it.gift_card || /gift-card/i.test(it.handle || '')) { updates[it.key] = 0; gifts++; }
        else if (!extra && /magazine/i.test(it.handle || '')) { updates[it.key] = 0; mags++; }
      });
      if (!mags && !gifts) return;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(function () {
        store.set('pk_intl_removed', { mags: mags, gifts: gifts });
        if (/^\/cart/.test(location.pathname)) location.reload();
        else document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    }).catch(function () {});
  }

  function start() {
    if (/\/(pages|collections)\/[^/]*magazine/i.test(location.pathname)) note('Magazines are currently unavailable for international orders. Our photobooks ship to ' + intl.name + ' in 7–10 working days.');
    var removed = store.get('pk_intl_removed');
    if (removed && /^\/cart/.test(location.pathname)) {
      store.set('pk_intl_removed', null);
      note((removed.mags ? 'Magazines are currently unavailable for international orders' : 'Gift cards are currently available in Egypt only') + ', so we took ' + (removed.mags + removed.gifts > 1 ? 'them' : 'it') + ' out of your cart.');
    }
    cleanCart();
    rate().then(function (fx) {
      if (!fx) return;
      paint(fx);
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { paint(fx); }, 120); })
        .observe(document.body, { childList: true, subtree: true, characterData: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Letter card page: the design button reads "Write your card" (PicLabs adds it with the store-wide label) */
(function () {
  if (!document.querySelector('.pk-pp[data-pk-card]')) return;
  var relabel = function () {
    var done = false;
    document.querySelectorAll('.pk-pp button, .pk-pp a').forEach(function (b) {
      if (/create your album/i.test(b.textContent)) {
        var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) { if (/create your album/i.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(/create your album/i, 'Write your card'); done = true; } }
      }
    });
    return done;
  };
  if (relabel()) return;
  var mo = new MutationObserver(function () { if (relabel()) mo.disconnect(); });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 15000);
})();
